import { render, staticRenderFns } from "./VacationList.vue?vue&type=template&id=e10f6048&"
import script from "./VacationList.vue?vue&type=script&lang=ts&"
export * from "./VacationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports